import { render, staticRenderFns } from "./UpsellRequestModal.vue?vue&type=template&id=6adeca1c&scoped=true&"
import script from "./UpsellRequestModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpsellRequestModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adeca1c",
  null
  
)

export default component.exports